import { createSelector } from 'reselect'
import { Finance } from 'finance'
import { selectDreamHomeMortgageRate } from 'src/store/selectors/mortgageRate'
import { selectCashFromSale, asDownPaymentPercent } from './equity'
import { dreamHome } from 'src/constants/equity'

export const selectDreamHomeDownPayment = selectCashFromSale
export const selectDreamHomeBudget = createSelector(
  selectDreamHomeDownPayment,
  asDownPaymentPercent(dreamHome.downPaymentPercent)
)

const selectBudgetAfterDownpayment = createSelector(
  selectDreamHomeBudget,
  selectDreamHomeDownPayment,
  (budget, downPayment) => budget - downPayment
)

export const selectDreamHomeMonthlyPayment = createSelector(
  selectBudgetAfterDownpayment,
  selectDreamHomeMortgageRate,
  (budget, rate) =>
    Finance.calculatePayment(budget, dreamHome.loanTerm * 12, rate)
)
